const selectors = {
  popoutWrappper: '[data-popout]',
  popoutList: '[data-popout-list]',
  popoutToggle: '[data-popout-toggle]',
  popoutInput: '[data-popout-input]',
  popoutOptions: '[data-popout-option]',
  dataValue: 'data-value',
  ariaExpanded: 'aria-expanded',
};

const classes = {
  listVisible: 'popout-list--visible',
};

let sections = {};

const popupToggleClick = function (evt) {
  const ariaExpanded = evt.currentTarget.getAttribute(selectors.ariaExpanded) === 'true';
  evt.currentTarget.setAttribute(selectors.ariaExpanded, !ariaExpanded);
  this.popoutList.classList.toggle(classes.listVisible);
};

const popupToggleFocusout = function (evt) {
  const popoutLostFocus = this.container.contains(evt.relatedTarget);

  if (!popoutLostFocus) {
    this._hideList();
  }
};

const popupListFocusout = function (evt) {
  const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
  const isVisible = this.popoutList.classList.contains(classes.listVisible);

  if (isVisible && !childInFocus) {
    this._hideList();
  }
};

const popupOptionsClick = function (evt) {
  const link = evt.target.closest(selectors.popoutOptions);
  if (link.attributes.href.value === '#') {
    evt.preventDefault();
    let attrValue = '';
    if (evt.currentTarget.getAttribute(selectors.dataValue)) {
      attrValue = evt.currentTarget.getAttribute(selectors.dataValue);
    }
    this._submitForm(attrValue);
  }
};

const containerKeyup = function (evt) {
  if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
    return;
  }
  this._hideList();
  this.popoutToggle.focus();
};

const bodyClick = function (evt) {
  const isOption = this.container.contains(evt.target);
  const isVisible = this.popoutList.classList.contains(classes.listVisible);

  if (isVisible && !isOption) {
    this._hideList();
  }
};

class Popout {
  constructor(popout) {
    this.container = popout;
    this.popoutList = this.container.querySelector(selectors.popoutList);
    this.popoutToggle = this.container.querySelector(selectors.popoutToggle);
    this.popoutInput = this.container.querySelector(selectors.popoutInput);
    this.popoutOptions = this.container.querySelectorAll(selectors.popoutOptions);

    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  unload() {
    if (this.popoutOptions.length) {
      this.popoutOptions.forEach((element) => {
        element.removeEventListener('click', popupOptionsClick);
      });
    }

    this.popoutToggle.removeEventListener('click', popupToggleClick);

    this.popoutToggle.removeEventListener('focusout', popupToggleFocusout);

    this.popoutList.removeEventListener('focusout', popupListFocusout);

    this.container.removeEventListener('keyup', containerKeyup);
  }

  _connectToggle() {
    this.popoutToggle.addEventListener('click', popupToggleClick.bind(this));
  }

  _connectOptions() {
    if (this.popoutOptions.length) {
      this.popoutOptions.forEach((element) => {
        element.addEventListener('click', popupOptionsClick.bind(this));
      });
    }
  }

  _onFocusOut() {
    this.popoutToggle.addEventListener('focusout', popupToggleFocusout.bind(this));

    this.popoutList.addEventListener('focusout', popupListFocusout.bind(this));

    this.container.addEventListener('keyup', containerKeyup.bind(this));

    document.body.addEventListener('click', bodyClick.bind(this));
  }

  _submitForm(value) {
    const form = this.container.closest('form');
    this.popoutInput.value = value;
    if (form) {
      form.submit();
    }
  }

  _hideList() {
    this.popoutList.classList.remove(classes.listVisible);
    this.popoutToggle.setAttribute(selectors.ariaExpanded, false);
  }
}

const popoutSection = {
  onLoad() {
    sections[this.id] = [];
    const wrappers = this.container.querySelectorAll(selectors.popoutWrappper);
    wrappers.forEach((wrapper) => {
      sections[this.id].push(new Popout(wrapper));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((popout) => {
      if (typeof popout.unload === 'function') {
        popout.unload();
      }
    });
  },
};

export default popoutSection;
